import { z } from "zod";
export const OpsPresentationPrivacySchema = z.enum([
    "MASK_CONTACT_DETAILS",
    "SHOW_CONTACT_DETAILS"
]);
const PHONE_CANDIDATE = /(?<![\p{L}\p{N}_@/])(?:\(\+\d{1,4}\)|\+?(?:\(\d{1,4}\)|\d))(?:[ \t\u00a0()-]*\d|\.(?=\d)\d){7,}(?![\p{L}\p{N}_@]|:\d+@)/gu;
const NON_PHONE_DATE = /^(?:(?:19|20)\d{2}[-.]\d{1,2}[-.]\d{1,2}(?:[ T]\d{1,2})?|(?:19|20)\d{6})$/u;
const IPV4_ADDRESS = /^(?:\d{1,3}\.){3}\d{1,3}$/u;
function personalPhoneCandidateDigits(text, candidate, offset) {
    const left = text.slice(0, offset).match(/\S*$/u)?.[0] ?? "";
    const right = text.slice(offset + candidate.length).match(/^\S*/u)?.[0] ?? "";
    const surroundingToken = (left + candidate + right).replace(/^[([{<"']+/u, "");
    if (surroundingToken.includes("://") || surroundingToken.startsWith("/") || surroundingToken.startsWith("#")) {
        return null;
    }
    const compact = candidate.trim();
    const digits = compact.replace(/\D/gu, "");
    if (digits.length < 8 || digits.length > 15)
        return null;
    if (NON_PHONE_DATE.test(compact) || IPV4_ADDRESS.test(compact))
        return null;
    if (/^\d{8}$/u.test(compact) && !/^[689]/u.test(compact))
        return null;
    return digits;
}
export function maskOpsPresentationPhoneNumbers(text) {
    return text.replace(PHONE_CANDIDATE, (candidate, offset) => {
        const digits = personalPhoneCandidateDigits(text, candidate, offset);
        if (!digits)
            return candidate;
        const compact = candidate.trim();
        const prefixLength = Math.min(2, digits.length - 4);
        const prefix = (compact.includes("+") ? "+" : "") + digits.slice(0, prefixLength);
        return prefix + "*".repeat(digits.length - prefixLength - 2) + digits.slice(-2);
    });
}
export function maskOpsPresentationPhoneNumbersPreservingOffsets(text) {
    return text.replace(PHONE_CANDIDATE, (candidate, offset) => {
        const digits = personalPhoneCandidateDigits(text, candidate, offset);
        if (!digits)
            return candidate;
        const prefixLength = Math.min(2, digits.length - 4);
        let digitIndex = 0;
        return candidate.replace(/\d/gu, (digit) => {
            const keep = digitIndex < prefixLength || digitIndex >= digits.length - 2;
            digitIndex += 1;
            return keep ? digit : "*";
        });
    });
}
// WHY [BOL-CANONICAL-PRESENTATION-PRIVACY-001]: the canonical TurnResult is
// one unmodified truth, while Private Mode is one deterministic presentation
// choice shared by Web paint/copy/action guards and Voice speech. Keeping this
// projection in Domain prevents either channel from inventing query-sensitive
// wording or applying a different phone mask. Falsifier: the same canonical
// text and privacy value produce different visible/heard text, Private speaks
// a contact number, or non-Private changes one canonical character.
export function projectOpsPresentationText(text, privacy) {
    return privacy === "MASK_CONTACT_DETAILS"
        ? maskOpsPresentationPhoneNumbers(text)
        : text;
}
//# sourceMappingURL=ops-presentation-privacy.js.map